const getRoot = () => {
  // Use env if provided, otherwise fallback to current domain
  if (process.env.VUE_APP_API_ROOT_URL) {
    return process.env.VUE_APP_API_ROOT_URL.replace(/\/+$/, "");
  }

  if (typeof window !== "undefined") {
    return window.location.origin.replace(/\/+$/, "");
  }

  return "";
};
//check auto deploy
const defaultRoot = getRoot();
console.log("domain", defaultRoot);
const defaultBaseUrl = `${defaultRoot}/api/v1`;
const defaultApiKey = "alth4332ifdfsfdsf4645fd342sfa456fdds";

const root = (process.env.VUE_APP_API_ROOT_URL || defaultRoot).replace(/\/+$/, "");

export const API_ROOT_URL = root;
export const API_BASE_URL = (process.env.VUE_APP_API_BASE_URL || defaultBaseUrl).replace(/\/+$/, "");
export const API_X_API_KEY = process.env.VUE_APP_X_API_KEY || defaultApiKey;
